<template>
  <div class="bg">
    <div class="banner">
      <img src="../../assets/goyb02.png" alt="" />
    </div>
    <div class="bg-con">
        <div style="display:flex;flex-direction: column;">
                <div class="activity-sidebar">
        <div class="sidebar-title">重大活动</div>
        <ul class="activity-list">
          <li v-for="activity in activityList" :key="activity.id" @click="goToActivity(activity)" >
            {{ activity.name }}
          </li>
        </ul>
        
      </div>
      <div class="activity-sidebar">
        <div class="sidebar-title">喜报</div>
        <ul class="activity-list">
            <router-link to="/honor/new9">
          <li v-for="activity in getInfoListXiBao" :key="activity.id" @click="choseNew(activity.id)" :class="{ active: activity.id === id }">
            {{ activity.mainTitle }}
            <!-- <span>{{ activity.publicationDate }}</span> -->
          </li>
          </router-link>
        </ul>
        
      </div>

            </div>
        <div style="flex:1;    padding: .06rem;
    padding-right: .3rem;">
      <div class="news-bar">
        <div class="left-text" v-if="this.getInfoById.type === '4'">喜报</div>
        <div class="left-text" v-else>新闻动态</div>

        <div class="right-text">
          <img
            src="../../assets/ryzs/weizhi.png"
            alt=""
            style="width: 20px; margin-right: 10px"
          />
          当前位置：
          <!-- <router-link to="/home" v-if="this.getInfoById.type === '4'">
            <div class="new_right">首页</div>
          </router-link> -->
          <!-- 从新闻动态点进来是返回列表 -->
          <router-link to="/honor/myzs6" >
            <div class="new_right">新闻动态</div>
          </router-link>
          <span>>></span>喜报
          <span>>></span>正文
        </div>
      </div>
      <div class="title">
        <h2 class="title1">{{ this.getInfoById.mainTitle }}</h2>
        <div v-if="this.getInfoById.subTitle">
          <p class="title2">——{{ this.getInfoById.subTitle }}</p>
        </div>
        <div style="font-weight: 400; margin-top: 10px">
          发布日期：{{ this.getInfoById.publicationDate.substring(0, 10) }}
        </div>
      </div>
      <hr />
      <div class="main">
        <div class="content" v-html="this.getInfoById.content"></div>
        <hr />
        <div class="new_next">
          <!-- <router-link to="/home" v-if="this.getInfoById.type === '4'">
            <div class="new_right">
              返回首页<img
                src="../../assets/ryzs/fanhui.png"
                alt=""
                style="width: 25px"
              />
            </div>
          </router-link> -->
          <router-link to="/honor/myzs6">
            <div class="new_right">
              返回列表<img
                src="../../assets/ryzs/fanhui.png"
                alt=""
                style="width: 25px"
              />
            </div>
          </router-link>
          <div class="new_left">【全文完】</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      id: localStorage.getItem("id") - 0,
      type:4,//喜报
      activityList: [
        { id: 1, name: '国机集团智能制造高峰论坛', path: '/case/CaseSix' },
        { id: 2, name: '中机六院成立70周年', path: '/case/CaseZJLY70' },
        { id: 3, name: '客户公司成立60周年', path: '/case/Case713' },
        { id: 4, name: '中秋月饼DIY', path: '/case/CaseDIY' },
        { id: 5, name: '女神节的祝福', path: '/case/Case38' },
        { id: 6, name: '恒天重工双节问候', path: '/case/CaseHT' },
        { id: 7, name: '冬至"饺"好运', path: '/case/Case713dz' }
      ]
    };
  },
  computed: {
    ...mapState("myZs6", ["getInfoById",'getInfoListXiBao']),
  },
  created() {
    this.getInfoByIdAction(this.id);
    this.getInfoAction(this.type)
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {
    ...mapActions("myZs6", ["getInfoByIdAction","getInfoAction"]),
    choseNew(id){
        localStorage.setItem('id',JSON.stringify(id))
    },
    goToActivity(activity) {
      // 跳转到对应活动详情页（这里使用路由 push）
      this.$router.push(activity.path);
      // 或者新窗口打开: window.open(activity.path, '_blank');
    }
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 3rem;
  overflow: hidden;
}
.banner:hover img {
  transform: scale(1.2);
}
.banner img {
  transition: all 0.4s;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.yy-box1 {
  margin: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f6f6f6;
}

/* 标题 */
/* 标题 */
.title {
  margin: 20px 0px;
  position: relative;
  height: 70px;
}
.title1 {
  font-size: 0.13rem;
}
.title2 {
  font-size: 22px;
  position: absolute;
  top: 15px;
  right: 50px;
}
hr {
  width: 60%;
  margin: 0 auto;
}
.main {
  /* width: 96%; */
  /* background-color: pink; */
  margin: 0.1rem auto;
}
.content p {
  text-indent: 2em;
  text-align: left;
  font-size: 0.1rem;
  line-height: 0.23rem;
}
.content .a1 {
  text-align: center;
  font-weight: 700;
}
.new_img1 {
  width: 800px;
  height: 400px;
  margin: 5px auto;
}
.new_img1 img {
  width: 100%;
  height: 100%;
}
/* 翻篇 */
.new_next {
  width: 100%;
  font-size: 0.09rem;
  display: flex;
  justify-content: space-between;
  padding: 0.09rem 0;
}
.new_next .new_right {
  display: flex;
  align-items: center;
}
.new_next .new_right:hover {
  color: #239074;
}
.main hr {
  width: 100%;
  margin-top: 0.2rem;
}
.bg {
  /* background-image: url("../../assets/bg.jpg"); */
  /* background-repeat: repeat; */
  /* background-size: 50% auto; */
}
.bg-con {
  background: #fff;
  width: 100%;
    max-width: 80%;
    /* margin-left: 10%; */
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 0 auto;
  padding: 20px;
}

.news-bar {
  background-color: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 24px;
  font-family: "Microsoft YaHei", sans-serif;
}
.left-text {
  font-weight: bold;
  color: #b62c28;
}
.right-text {
  color: #666;
  font-size: 16px;
  display: flex;
}
.right-text span {
  color: #999;
}

/* 左侧侧边栏 */
.activity-sidebar {
  width: 260px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: fit-content;
      margin: 20px 0;
}
.sidebar-title {
  background: linear-gradient(90deg, #f97316, #facc15);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 14px 0;
}
.activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.activity-list li {
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  border-left: 3px solid transparent;
}
.activity-list li:hover {
  background: #fef3e2;
  border-left-color: #f97316;
  color: #f97316;
}
.activity-list li:active {
  background: #fef3e2;
  color: #f97316!important;
  border-left-color: #f97316!important;
}
.active {
   background: #fef3e2;
  color: #f97316!important;
  border-left-color: #f97316!important;
}
</style>
